import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import { Card } from 'react-bootstrap';
import IntegrationTable from './IntegrationTable';
import { integrationCols, mockData } from './integrationCols';

// const data = mockData.map(item => ({
//   license: item.license,
//   apikey: item.apikey,
//   apikeyName: item.apikeyName,
//   realEstate: item.realEstate,
//   branchOffice: item.branchOffice,
//   user: item.user,
//   propsPublished: item.propsPublished
// }));

const RealEstateIntegration = () => {
  return (
    <>
      <PageHeader
        title="Inmobiliarias Integradas"
        description="Gestiona las inmobiliarias que hayan generado API Keys de integración al sistema "
        className="mb-3 bg-white"
      />
      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between">
          <Card.Title className="fw-light d-flex align-items-center gap-2">
            <span className="fs-0">
              <FontAwesomeIcon icon="fa-solid fa-list" />
            </span>

            <span>Listado</span>
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <IntegrationTable columns={integrationCols} data={mockData} />
        </Card.Body>
      </Card>
    </>
  );
};

export default RealEstateIntegration;
